import { Box, Button, Heading, Image, Link, useStyleConfig } from '@chakra-ui/react';
import { editResults } from '../utils';
import React from 'react';
import { FaDownload } from 'react-icons/fa';
import { onDownload, onLink } from '../../../handlers';

const Results = ({ iu, styles }) => {
  const titles = iu.get_title_and_subTitle();
  const appType = window.appType;
  return (
    <Box sx={{ ...styles.interview }}>
      <Box className="interviewWrapper" border="none !important">
        <Box area="form" className="interviewFormWrapper">
          <Box width='55%'>
            <Heading>{titles.title}</Heading>
            <Box>{titles.subTitle}</Box>
          </Box>
          <Box className="editButtonWrap">
            <Box className="results" width="60%">
              <Box className="resultsInner">
                {iu.results.questions !== null && (
                  <Box>
                    <Heading fontSize="22px">Sample questions you can use this response for:</Heading>
                    <Box padding="1rem 2rem">
                      <ol>
                        {Object.values(iu.results.questions).map((quest, index) => {
                            return (
                              <li key={`question-${index}`}>{quest}</li>
                            );
                          },
                        )}
                      </ol>
                    </Box>
                  </Box>
                )}
                  <Box>
                    {Object.values(iu.results.interview).map((paragraph, index) => {
                        // Check if paragraph is an object or string
                        return (
                          <Box marginTop="1rem" key={`paragraph-${index}`}>
                            {typeof paragraph === 'object'
                              ? JSON.stringify(paragraph) // Convert object to string or extract specific property
                              : paragraph}
                          </Box>
                        );
                      },
                    )}
                  </Box>

              </Box>
              <Box display="flex" justifyContent="space-between">
                {appType === '' && (
                <Box className="editButtonWrap">
                  <Button
                    sx={{...styles.button.primary,...styles.button.singleSectionMenu}}
                    onClick={(e) => {

                    onLink(false, iu.formikProps, iu.stateProps, 'interview')
                  }}>&lt;&lt; Menu</Button>
                </Box>
                  )}
                <Box className="editButtonWrap">
                  <Button
                    marginTop='1rem'
                    onClick={(e) => {
                    iu.editResults();
                  }}>Start Again</Button>
                </Box>
                {appType === '' && (
                <Box className="editButtonWrap" marginTop='1rem'>
                  <Button
                    marginTop='1rem !important'
                    variant='download'
                    leftIcon={<FaDownload />}
                    onClick={e => iu.download(iu)} sx={{...styles.button.download}} >
                    Download
                  </Button>
                </Box>
                  )}
              </Box>
            </Box>
            <Box className="heroImageBox heroImageRight" width="40%" margin="3rem 0 0 5rem">
              <Image className="heroImageImg" src={iu.interviewImage2} />
            </Box>
          </Box>
        </Box>

      </Box>
    </Box>
  );
};
export default Results;

/*

                {iu.sectionName === 'new-aptitude' ? (
                  <Box>
                    {Object.values(iu.results.interview).map((assessment, index) => {
                        return (
                          <Box paddingBottom="2rem" key={`assessment-${index}`}>
                            <Box fontWeight="bold" fontSize="18px">{assessment.title}</Box>
                            <Box padding="1rem 0">{assessment.text}</Box>
                            <Link paddingBottom="2rem" color="blue" href={assessment.link} isExternal>Read
                              More: {assessment.link}</Link>
                          </Box>
                        );
                      },
                    )}
                  </Box>
                ) : (
                  // For non-aptitude sections, handle paragraphs differently
 */